module.exports = __webpack_public_path__ + "static/media/img_fenlei10.a305ef9e.png";